<template>
  <div class="list-wrapper">
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索付款方名称" v-model="searchParams.purchaserName">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchParams.status"
            :options="statusOptions"
            @change="changeStatus"
          />
          <van-dropdown-item
            v-model="searchParams.invoiceType"
            :options="invoiceTypeOptions"
            @change="changeType"
          />
          <van-dropdown-item
            v-model="searchOptions.applyDate"
            :options="applyDateOptions"
            @change="changeApplyDate"
          />
        </van-dropdown-menu>
        <p class="filter-btn" @click="openAllCard" v-if="!cardOpened">批量删除</p>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell v-for="(invoice, index) in invoiceList" :key="index" :ref="'swipecell'+invoice.id" :name="invoice.id" :disabled="true" :before-close="beforeClose" :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')">
            <slot slot="left" name="left">
              <div class="select-wrp" v-if="!checkCouldDelete(invoice)"><i class="iconfont select-font-disabled">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="!invoice.select"><i class="iconfont select-font" v-tap="{methods: selectInvoice, params:{invoice}}">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="invoice.select"><i class="iconfont select-font-active" v-tap="{methods: cancelInvoice, params:{invoice}}">&#xe69d;</i></div>
            </slot>
            <InvoiceCard
              type="apply"
              :invoice="invoice"
              :btnList="getBtnList(invoice)"
              :cardClickType="getCardClickType(invoice)"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="select-footer" v-if="this.cardOpened">
      <div class="wrp">
        <div class="select-wrp" v-if="selectCount === 0 || selectCount !== getCouldDeleteCount(invoiceList)"><i class="iconfont select-font" v-tap="{methods: selectAllInvoice, params:{}}">&#xe69c;</i></div>
        <div class="select-wrp" v-else ><i class="iconfont select-font-active" v-tap="{methods: cancelAllInvoice, params:{}}">&#xe69d;</i></div>
        <div class="content">全选</div>
        <div class="content">已选择<span>{{selectCount}}张</span>申请</div>
      </div>
      <div class="btn-wrp">
        <van-button
          class="btn"
          round
          @click="closeAllCard"
        >
          取消
        </van-button>
        <van-button
          class="btn"
          round
          @click="deleteSelect"
        >
          批量删除
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { invoiceRequest } from '@services'
import InvoiceCard from '@components/InvoiceCard'
import {
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  SwipeCell,
  Button,
  Notify
} from 'vant'
import moment from 'moment'
import Observer from '@utils/observer'

const BATCH_IMPORT_SETTLEMENT_SOURCE = 14

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Notify.name]: Notify,
    [Button.name]: Button,
    InvoiceCard
  },
  props: {},
  data () {
    return {
      statusOptions: [
        { text: ' 全部状态', value: undefined },
        { text: '未开具', value: '0,1,2' },
        // { text: '部分开具', value: 1 },
        { text: '开票成功', value: '3' },
        { text: '开票失败', value: '4' }
      ],
      invoiceTypeOptions: [
        { text: '全部类型', value: undefined },
        { text: '专票', value: '1' },
        { text: '普票', value: '2' },
        { text: '电子普票', value: '3' },
        { text: '电子专票', value: '4' },
        { text: '数电普票', value: '7' },
        { text: '数电专票', value: '8' }
      ],
      applyDateOptions: [
        { text: '申请日期', value: undefined }
      ],
      checkCouldDelete (invoice) {
        if (invoice.status === 1 || invoice.status === 0) {
          if (invoice.settlementSource === 7) { // 电票直开
            if (invoice.valid === 0) { // 15天之外的可以删除
              return true
            }
          }
          return true
        }
        return false
      },
      searchParams: {
        size: 25,
        current: 1,
        purchaserName: '',
        status: undefined
      },
      searchOptions: {
        applyDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: false,
      cardOpened: false,
      selectCount: 0
    }
  },
  computed: {

  },
  watch: {},
  created () {
  },
  mounted () {
    let { searchParams, searchOptions } = this.$store.state.invoice.invoiceHomeApplySearch
    this.searchParams = searchParams
    this.searchOptions = searchOptions
    this.initApplyDateOptions()
    this.getList()
    Observer.setFunction({ type: 'changeCompany', fn: this.companyChangeRefresh })
  },
  activated () {},
  updated () {},
  methods: {
    companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/invoice/invoice-home?active=0' || window.location.pathname + window.location.search === '/invoice/invoice-home') {
        this.onRefresh()
      }
    },
    getList () {
      this.getApplyList()
    },
    getBtnList (invoice) {
      if (this.isBatchImportInvoice(invoice)) { // 待开发票批量导入
        if (invoice.status === 0 || invoice.status === 1) {
          return ['edit', 'delete']
        } else if (this.isInvoiced(invoice)) {
          return ['settlementInvoicePreview']
        } else if (this.isInvoiceFailed(invoice)) {
          return ['delete']
        }
        return []
      } else if (this.isSelfPlant(invoice)) { // 自有税盘
        if (this.isNotInvoiced(invoice)) { // 未开具 编辑/删除
          return ['edit', 'delete']
        } else if (this.isInvoiced(invoice)) {
          return ['settlementInvoicePreview']
        } else if (this.isInvoiceFailed(invoice)) {
          return ['delete']
        }
        return []
      } else if (this.isIssuedInvoice(invoice)) { // 税局代开
        if (this.isNotInvoiced(invoice)) { // 未开具
          return ['edit', 'delete']
        } else if (this.isInvoiced(invoice)) {
          if (invoice.matchFlag === 1) { // 匹配到了发票
            return ['settlementInvoicePreview']
          }
        } else if (this.isInvoiceFailed(invoice)) {
          return ['delete']
        }
        return []
      } else if (this.isCustomInvoice(invoice)) { // 电票直开
        if (this.isNotInvoiced(invoice)) {
          if (invoice.valid === 0) {
            return ['delete']
          }
          // return ['customApplyDetail']
        } else if (this.isInvoiced(invoice)) {
          return ['settlementInvoicePreview']
        } else if (this.isInvoiceFailed(invoice)) {
          return []
        }
        return []
      } else if (this.isApplyInvoice(invoice)) { // 是否是申请开票
        if (this.isNotInvoiced(invoice)) {
          if (invoice.approvalStatus === 3) { // 已撤销状态可以删除
            return ['delete']
          }
          // return ['customApplyDetail']
        } else if (this.isInvoiced(invoice)) {
          return ['settlementInvoicePreview']
        } else if (this.isInvoiceFailed(invoice)) {
          return []
        }
        return []
      }
      return []
    },
    isNotInvoiced (invocie) { // 判断是否是未开具的票
      if (invocie.status === 0 || invocie.status === 1 || invocie.status === 2) {
        return true // 未开具
      }
      return false
    },
    isInvoiced (invocie) { // 判断是否是开具成功的票
      if (invocie.status === 3) {
        return true // 开具成功
      }
      return false
    },
    isInvoiceFailed (invocie) { // 判断是否是开具失败的票
      if (invocie.status === 4) {
        return true // 开具失败
      }
      return false
    },
    isSelfPlant (invoice) { // 判断是否是自有税盘
      if (invoice.proxyFlag === 0 && invoice.settlementSource !== 7 && invoice.settlementSource !== 12 && !this.isBatchImportInvoice(invoice)) {
        return true
      }
      return false
    },
    isBatchImportInvoice (invoice) { // 判断是否是待开发票批量导入
      return invoice.settlementSource === BATCH_IMPORT_SETTLEMENT_SOURCE
    },
    isIssuedInvoice (invoice) { // 判断是否是税局代开
      if (invoice.proxyFlag === 1 && invoice.settlementSource !== 7 && invoice.settlementSource !== 12) {
        return true
      }
      return false
    },
    isCustomInvoice (invoice) { // 判断是否是电票直开
      if (invoice.settlementSource === 7) {
        return true
      }
      return false
    },
    isApplyInvoice (invoice) { // 判断是否是移动端申请开票
      if (invoice.settlementSource === 12) {
        return true
      }
      return false
    },
    getCardClickType (invoice) {
      if (invoice.settlementSource === 7) {
        return 'customApplyDetail'
      }
      return 'applyDetail'
    },
    initApplyDateOptions () {
      let applyDateOptions = [
        { text: '申请日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        applyDateOptions.push({ text: value, value: value })
      }
      this.applyDateOptions = applyDateOptions
    },
    async getApplyList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await invoiceRequest.apply.getMobileApplyList(this.searchParams)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.cardOpened) {
            this.$nextTick(() => {
              this.openAllCard()
            })
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    async deleteSelect () {
      let ids = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          ids.push(v.id)
        }
      })
      if (!ids.length) {
        Notify({ type: 'danger', message: '请选择要删除的申请' })
        return
      }
      const data = await invoiceRequest.apply.batchDelete({ ids: ids })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.$router.go(0)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getApplyList()
    },
    onLoad () {
      this.searchParams.current++
      this.getApplyList()
    },
    changeStatus (value) {
      this.searchParams.status = value
      this.onRefresh()
    },
    changeType (value) {
      this.searchParams.changeType = value
      this.onRefresh()
    },
    changeApplyDate (value) {
      if (value) {
        this.searchParams.startTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
      this.onRefresh()
    },
    selectInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = true
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    cancelInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = false
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    selectAllInvoice (data) {
      this.invoiceList.forEach(v => {
        if (this.checkCouldDelete(v)) {
          v.select = true
        }
      })
      this.selectCount = this.getCouldDeleteCount(this.invoiceList)
    },
    getCouldDeleteCount (list) {
      return list.filter(v => this.checkCouldDelete(v)).length
    },
    cancelAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = false
      })
      this.selectCount = 0
    },
    openAllCard () {
      this.cardOpened = true
      Object.keys(this.$refs).forEach(key => {
        if (key.includes('swipecell')) {
          this.$refs[key][0] && this.$refs[key][0].open('left')
        }
      })
    },
    closeAllCard () {
      this.cardOpened = false
      Object.keys(this.$refs).forEach(key => {
        if (key.includes('swipecell')) {
          this.$refs[key][0] && this.$refs[key][0].close('left')
        }
      })
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    }
  },
  beforeDestroy () {
    let params = {
      searchParams: {
        ...this.searchParams,
        current: 1
      },
      searchOptions: this.searchOptions
    }
    this.$store.commit('invoice/saveInvoiceHomeApplySearch', params)
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
